
const worksData = [
  {
    id: 1,
    title: 'Sutle',
    description:
      'A platform for saving and organizing online resources into a directed learning path. Built it for fun and as a way to learn some techs. Got featured on Product Hunt. Also the creation of Sutle led to the birth of Minorui, my personal ReactJS component library.',
    auth: '',
    techs: 'TypeScript, NextJS, ReactJS, Stitches, Radix UI, Minorui, TypeGraphQL, TypeORM, PostgreSQL, Apollo, Redis, Mailgun, Heroku, Vercel, GitHub',
    link: 'https://sutle.io/',
    image: 'sutle.png',
    repo: 'https://github.com/jorenrui/sutle-app/',
    isDemo: true,
    className: ''
  },
  {
    id: 2,
    title: 'Lyon App',
    description:
      'Worked as a Full Stack Developer at Lyon. Fixed bugs and developed major features like profile and event management pages. Mainly developed the on-demand courses product from designing the database, developing the APIs, creating the frontend and connecting the payment.',
    auth: '',
    techs: 'TypeScript, NextJS, ReactJS, Styletron, BaseWeb, NodeJS, Ruby on Rails, KoaJS, Firebase, REST, GraphQL, PostgreSQL, TypeORM',
    link: 'https://lyon.com.ph/',
    image: 'lyon.png',
    repo: null,
    isDemo: false,
    className: 'no-shadow'
  },
  {
    id: 3,
    title: 'React Portfolio',
    description:
      'A personal portfolio built on Nov 2019 as a way to start diving into the world of ReactJS. Developed the design using Figma, developed the layout using Flexbox and CSS Grid, and used ReactJS.',
    auth: '',
    techs: 'ReactJS',
    link: '',
    image: 'react-portfolio.png',
    repo: 'https://github.com/jorenrui/portfolio',
    isDemo: true,
    className: 'no-shadow'
  },
  {
    id: 4,
    title: 'SPCC Caloocan Portal',
    description:
      'SPCC Caloocan Portal is a Laravel application that focuses on the grading system and the school website. It also has features like class scheduling, course enlistment, printing of grades, enrollment of students, curriculum builder, etc. Did some UI/UX Design, Database Design, and Front & Back-end Development.',
    auth: '',
    techs: 'Boostrap, jQuery, Laravel, etc.',
    link: '',
    image: 'spcc-portal.png',
    repo: 'https://github.com/jorenrui/spccweb',
    isDemo: true,
    className: ''
  },
];

export default worksData;
